/**
 * Aligne le widget AfterSell sur les sections de recommandations du thème.
 *
 * AfterSell rend son widget dans un shadow root : les feuilles de style du
 * thème ne l'atteignent pas, et l'application n'expose ni ::part ni variables
 * CSS. Le seul point d'entrée est le shadow root lui-même, ouvert, dans lequel
 * on insère une feuille de style.
 *
 * Cela vise des classes internes à AfterSell (.product-card, .add-button…) :
 * ce sont des détails d'implémentation, susceptibles de changer à toute mise à
 * jour de l'application, auquel cas la mise en forme redeviendrait celle
 * d'AfterSell sans rien casser d'autre.
 */
(function () {
  'use strict';

  var HOST_ID = 'aftersell-pdp-upsell';
  var MARK = 'data-cc-theme-styles';

  /* Valeurs relevées sur les cartes du thème dans « Continuer à magasiner »
     (assets/custom.css, section « Carte produit ») : titre de section 19px/500
     en #174733 sans majuscules ; nom du produit en Playfair Display 900 à
     1,15em, interligne 1,2 ; image carrée bord à bord ; texte en retrait de
     20px ; bouton vert foncé #174733 aux coins de 10px. Playfair Display est
     déclarée dans le document par snippets/font-playfair-display.liquid (rendu
     par la section des recommandations) : les @font-face du document valent
     aussi dans le shadow root. */
  var CSS = [
    /* Panneau : on retire le cadre gris de l'application, les sections du
       thème posent leur propre respiration. Maven Pro, police du texte du
       thème, est héritée par tout le widget (.pdp-widget *{font-family:inherit}). */
    '.pdp-widget{background:transparent!important;padding:0!important;border-radius:0!important;',
    'box-shadow:none!important;font-family:"Maven Pro",sans-serif!important}',

    /* En-tête aligné sur .section-heading du thème. */
    '.upsell-header{font-family:"Maven Pro",sans-serif!important;font-weight:500!important;',
    'font-size:19px!important;line-height:26.6px!important;text-align:left!important;',
    /* AfterSell ajoute 20px de padding-bottom sous l'en-tête ; combiné à une
       marge de 1em cela donnait 39px entre le titre et les cartes, contre
       13,3px dans les sections du thème. */
    'text-transform:none!important;margin:0 0 13.3px!important;padding-bottom:0!important;',
    'color:#174733!important}',

    /* Carte produit : fond blanc, filet léger, sans marge intérieure pour que
       l'image touche les bords comme sur les cartes du thème. */
    '.product-card{background:#fff!important;border:1px solid rgba(44,37,40,.14)!important;',
    'border-radius:3px!important;box-shadow:none!important;overflow:hidden!important;',
    'padding:0!important;gap:0!important;transition:box-shadow .25s ease}',

    /* Image carrée bord à bord. AfterSell la plafonnait à 150 px de haut dans
       un cadre encadré par la marge intérieure de la carte. */
    '.product-image-wrapper{height:auto!important;width:100%!important;max-width:none!important}',
    '.product-image{width:100%!important;height:auto!important;aspect-ratio:1!important;',
    'max-height:none!important;object-fit:cover!important;border:0!important;border-radius:0!important}',

    /* Texte et actions en retrait de 20px, comme le réglage « gutter » des cartes. */
    '.horizontal-layout-divider,.vertical-layout-divider{padding:16px 20px 20px!important}',

    /* Nom du produit dans la police du H1 des collections, comme les cartes du thème. */
    '.product-title{font-family:"Playfair Display",Georgia,"Times New Roman",serif!important;',
    'font-weight:900!important;font-size:18.4px!important;line-height:1.2!important;',
    'color:#2c2528!important;transition:color .2s}',
    /* AfterSell met line-height:0 sur les liens du widget. */
    '.product-title a{color:inherit!important;line-height:inherit!important;text-decoration:none!important}',

    '.price-info,.discounted-price-wrapper,.discount-label-price-wrapper{',
    'font-family:"Maven Pro",sans-serif!important;font-size:16px!important;',
    'font-weight:400!important;line-height:22.4px!important;color:#2c2528!important}',
    '.price-info.compare-at-price{color:#2c2528!important;opacity:.7}',

    /* Bouton repris du bouton d'achat rapide des cartes du thème. */
    '.add-button{background:#174733!important;border:2px solid #174733!important;',
    'border-radius:10px!important;color:#fff!important;font-family:"Maven Pro",sans-serif!important;',
    'font-size:14.4px!important;font-weight:400!important;text-transform:none!important;height:44px!important}',
    '.add-button:hover{background:#0f3325!important;border-color:#0f3325!important}',

    /* Sélecteur de variante aligné sur les coins du bouton. */
    '.select-wrap{border-radius:10px!important}',
    '.select-dropdown{border-radius:10px!important;font-family:"Maven Pro",sans-serif!important;',
    'font-size:14px!important;color:#2c2528!important;height:44px!important}',
    '.variant-label-text{font-size:14px!important;color:#2c2528!important}',

    /* Survol, sur les écrans à souris : même effet que les cartes du thème. */
    '@media (hover:hover) and (min-width:1025px){',
    '.product-card:hover{box-shadow:0 4px 14px rgba(0,0,0,.08)!important}',
    '.product-card:hover .product-title{color:#06591a!important}}'
  ].join('');

  function apply(root) {
    if (!root || root.querySelector('style[' + MARK + ']')) return;
    var style = document.createElement('style');
    style.setAttribute(MARK, '');
    style.textContent = CSS;
    root.appendChild(style);
  }

  function attach() {
    var host = document.getElementById(HOST_ID);
    if (!host || !host.shadowRoot) return false;
    apply(host.shadowRoot);

    // Le widget se reconstruit au changement de variante : on repose la
    // feuille si AfterSell a vidé son shadow root.
    new MutationObserver(function () {
      apply(host.shadowRoot);
    }).observe(host.shadowRoot, { childList: true });
    return true;
  }

  // Le widget arrive après le chargement, via le script de l'application.
  if (!attach()) {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (attach() || tries > 40) clearInterval(timer);
    }, 250);
  }
})();
